/* ==========================================================================
   AFRODITA — theme.js
   Korpa (AJAX), drawer-i, pretraga, varijante, lista želja, chat, toast.
   Bez ijedne spoljne biblioteke.
   ========================================================================== */
(function () {
  "use strict";

  var T = window.AFRODITA || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  /* --------------------------------- helpers -------------------------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }

  function store(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) { return fallback; }
  }
  function save(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* privatni režim */ }
  }

  /* ---------------------------------- toast --------------------------------- */
  var toastStack;
  function toast(message) {
    if (!message) return;
    if (!toastStack) {
      toastStack = document.createElement("div");
      toastStack.className = "toast-stack";
      toastStack.setAttribute("role", "status");
      toastStack.setAttribute("aria-live", "polite");
      document.body.appendChild(toastStack);
    }
    var el = document.createElement("div");
    el.className = "toast";
    el.textContent = message;
    toastStack.appendChild(el);
    setTimeout(function () {
      el.style.transition = "opacity .3s";
      el.style.opacity = "0";
      setTimeout(function () { el.remove(); }, 300);
    }, 3200);
  }
  T.toast = toast;

  /* --------------------------------- drawers -------------------------------- */
  var lastFocused = null;

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocused = document.activeElement;
    d.classList.add("is-open");
    d.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    var focusable = d.querySelector("[autofocus], button, a[href], input, select, textarea");
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeDrawer(id) {
    var d = id ? document.getElementById(id) : document.querySelector(".drawer.is-open");
    if (!d) return;
    d.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () {
      if (!d.classList.contains("is-open")) d.setAttribute("hidden", "");
    }, 320);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  T.openDrawer = openDrawer;
  T.closeDrawer = closeDrawer;

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute("data-drawer-open")); return; }
    var closer = e.target.closest("[data-drawer-close]");
    if (closer) { e.preventDefault(); closeDrawer(closer.getAttribute("data-drawer-close") || null); return; }
    if (e.target.classList && e.target.classList.contains("drawer__overlay")) closeDrawer();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (document.querySelector(".drawer.is-open")) { closeDrawer(); return; }
    var so = $(".search-overlay.is-open");
    if (so) closeSearch();
  });

  /* ------------------------------ sticky header ----------------------------- */
  var header = $("[data-sticky-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* --------------------------- Section Rendering API ------------------------ */
  /* Sekcije se traže sa TRENUTNE putanje — samo tamo su i renderovane.
     (cart-drawer je u layout-u pa postoji svuda, main-cart samo na /cart.) */
  function renderSections(ids) {
    var url = window.location.pathname + "?sections=" + ids.join(",");
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); });
  }

  function replaceSection(id, html) {
    var target = document.getElementById("shopify-section-" + id);
    if (!target || !html) return;
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    var fresh = tmp.querySelector("#shopify-section-" + id);
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  function refreshCartUI(openAfter) {
    var ids = ["cart-drawer"];
    if (document.getElementById("shopify-section-main-cart")) ids.push("main-cart");
    return renderSections(ids).then(function (data) {
      ids.forEach(function (id) { replaceSection(id, data[id]); });
      return fetch(routes.cart + ".js").then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      if (openAfter) openDrawer("cart-drawer");
      return cart;
    });
  }

  function updateCartCount(count) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
    $$("[data-cart-count-label]").forEach(function (el) {
      el.setAttribute("aria-label", (strings.cartLabel || "Korpa") + ", " + count);
    });
  }

  /* ----------------------------- dodavanje u korpu -------------------------- */
  function addToCart(payload, btn) {
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.dataset.loading = "1"; }
    return fetch(routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body.description || res.body.message || strings.cartError || "Dodavanje nije uspelo.");
          return null;
        }
        return refreshCartUI(true).then(function () {
          toast(strings.added || "Dodato u korpu.");
          return res.body;
        });
      })
      .catch(function () { toast(strings.cartError || "Dodavanje nije uspelo."); return null; })
      .finally(function () {
        if (btn) { btn.removeAttribute("aria-disabled"); delete btn.dataset.loading; }
      });
  }
  T.addToCart = addToCart;

  /* Forme za dodavanje u korpu (kartica proizvoda i strana proizvoda) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    var payload = { items: [{ id: Number(data.get("id")), quantity: Number(data.get("quantity") || 1) }] };
    var btn = form.querySelector("[type=submit]");
    var buyNow = form.dataset.buyNow === "1";
    addToCart(payload, btn).then(function (ok) {
      if (ok && buyNow) window.location.href = routes.checkout;
    });
  });

  /* "Kupi odmah" — doda u korpu pa vodi na naplatu */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-buy-now]");
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest("form");
    if (!form) return;
    form.dataset.buyNow = "1";
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    setTimeout(function () { delete form.dataset.buyNow; }, 50);
  });

  /* ------------------------- izmena količine u korpi ------------------------ */
  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartUI(false); })
      .catch(function () { toast(strings.cartError || "Izmena nije uspela."); });
  }

  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-line-step]");
    if (step) {
      e.preventDefault();
      var wrap = step.closest("[data-line-key]");
      if (!wrap) return;
      var current = parseInt(wrap.getAttribute("data-line-qty"), 10) || 0;
      var next = current + parseInt(step.getAttribute("data-line-step"), 10);
      changeLine(wrap.getAttribute("data-line-key"), Math.max(0, next));
      return;
    }
    var rm = e.target.closest("[data-line-remove]");
    if (rm) {
      e.preventDefault();
      var w = rm.closest("[data-line-key]");
      if (w) changeLine(w.getAttribute("data-line-key"), 0);
    }
  });

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-line-input]");
    if (!input) return;
    var wrap = input.closest("[data-line-key]");
    if (wrap) changeLine(wrap.getAttribute("data-line-key"), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ------------------------------ količina (+/-) ---------------------------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty-step]");
    if (!b) return;
    e.preventDefault();
    var box = b.closest(".qty");
    var input = box && box.querySelector("input");
    if (!input) return;
    var min = parseInt(input.getAttribute("min"), 10) || 1;
    var val = (parseInt(input.value, 10) || min) + parseInt(b.getAttribute("data-qty-step"), 10);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* -------------------------------- akordeon -------------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest(".accordion__trigger");
    if (!t) return;
    e.preventDefault();
    var item = t.closest(".accordion__item");
    var open = item.classList.toggle("is-open");
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* ------------------------------- galerija --------------------------------- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest("[data-gallery]");
    var main = gallery && gallery.querySelector("[data-gallery-main]");
    if (!main) return;
    main.src = thumb.getAttribute("data-src");
    main.srcset = thumb.getAttribute("data-srcset") || "";
    main.alt = thumb.getAttribute("data-alt") || "";
    $$("[data-gallery-thumb]", gallery).forEach(function (t) { t.classList.remove("is-active"); });
    thumb.classList.add("is-active");
  });

  function showGalleryImage(mediaId) {
    var thumb = $('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  }

  /* ------------------------------- varijante -------------------------------- */
  $$("[data-variant-picker]").forEach(function (picker) {
    var dataEl = $("[data-variant-json]", picker);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var root = picker.closest("[data-product-root]") || document;
    var idInput = $("[data-variant-id]", root);
    var priceNow = $("[data-price-now]", root);
    var priceWas = $("[data-price-was]", root);
    var priceSave = $("[data-price-save]", root);
    var stockLine = $("[data-stock-line]", root);
    var addBtn = $("[data-add-button]", root);
    var buyBtn = $("[data-buy-now]", root);
    var specVolume = $("[data-spec-volume]", root);
    var specPack = $("[data-spec-pack]", root);

    function select(variantId) {
      var v = null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === variantId) { v = variants[i]; break; }
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.innerHTML = v.price;
      if (priceWas) {
        if (v.compare_at) { priceWas.innerHTML = v.compare_at; priceWas.removeAttribute("hidden"); }
        else priceWas.setAttribute("hidden", "");
      }
      if (priceSave) {
        if (v.discount > 0) { priceSave.textContent = (strings.save || "UŠTEDA") + " " + v.discount + "%"; priceSave.removeAttribute("hidden"); }
        else priceSave.setAttribute("hidden", "");
      }
      if (stockLine) {
        var dot = stockLine.querySelector(".stock-dot");
        var label = stockLine.querySelector("[data-stock-text]");
        if (dot) dot.classList.toggle("is-in", !!v.available);
        if (label) label.textContent = v.available ? (strings.inStock || "Na stanju — šaljemo isti radni dan") : (strings.outOfStock || "Trenutno nedostupno");
      }
      [addBtn, buyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        if (b === addBtn) {
          var txt = b.querySelector("[data-add-text]");
          if (txt) txt.textContent = v.available ? (strings.addToCart || "DODAJ U KORPU") : (strings.soldOut || "RASPRODATO");
        }
      });
      if (specVolume && v.ml) specVolume.textContent = v.ml + " ml";
      if (specPack) specPack.textContent = v.title;

      $$("[data-variant-option]", picker).forEach(function (btn) {
        btn.classList.toggle("is-active", Number(btn.getAttribute("data-variant-option")) === v.id);
        btn.setAttribute("aria-pressed", Number(btn.getAttribute("data-variant-option")) === v.id ? "true" : "false");
      });

      if (v.media_id) showGalleryImage(v.media_id);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url.toString());
      }
    }

    on(picker, "click", function (e) {
      var btn = e.target.closest("[data-variant-option]");
      if (!btn) return;
      e.preventDefault();
      select(Number(btn.getAttribute("data-variant-option")));
    });
    on(picker, "change", function (e) {
      var sel = e.target.closest("select[data-variant-select]");
      if (sel) select(Number(sel.value));
    });
  });

  /* ------------------------------ lista želja ------------------------------- */
  var WISH_KEY = "afrodita.wishlist.v1";

  function getWishlist() {
    var w = store(WISH_KEY, []);
    return Array.isArray(w) ? w : [];
  }

  function paintWishButtons() {
    var list = getWishlist();
    $$("[data-wish]").forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute("data-wish")) !== -1;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("aria-label", active ? (strings.wishRemove || "Ukloni iz liste želja") : (strings.wishAdd || "Dodaj u listu želja"));
    });
    var count = list.length;
    $$("[data-wish-count]").forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wish]");
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute("data-wish");
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); toast(strings.wishAdded || "Dodato u listu želja."); }
    else { list.splice(i, 1); toast(strings.wishRemoved || "Uklonjeno iz liste želja."); }
    save(WISH_KEY, list);
    paintWishButtons();
    if (document.querySelector("[data-wishlist-grid]")) renderProductList("[data-wishlist-grid]", list);
  });

  paintWishButtons();

  /* --------------------------- nedavno pregledano --------------------------- */
  var VIEWED_KEY = "afrodita.viewed.v1";
  var current = document.body.getAttribute("data-product-handle");
  if (current) {
    var viewed = store(VIEWED_KEY, []);
    if (!Array.isArray(viewed)) viewed = [];
    viewed = [current].concat(viewed.filter(function (h) { return h !== current; })).slice(0, 8);
    save(VIEWED_KEY, viewed);
  }

  /* Renderuje kartice proizvoda po handle-u kroz Section Rendering API. */
  function renderProductList(selector, handles) {
    var grid = $(selector);
    if (!grid) return;
    var empty = grid.parentElement.querySelector("[data-list-empty]");
    var section = grid.getAttribute("data-card-section") || "product-card-render";
    var list = (handles || []).filter(Boolean).slice(0, 12);

    if (list.length === 0) {
      grid.innerHTML = "";
      grid.setAttribute("hidden", "");
      if (empty) empty.removeAttribute("hidden");
      return;
    }
    if (empty) empty.setAttribute("hidden", "");
    grid.removeAttribute("hidden");

    Promise.all(list.map(function (handle) {
      return fetch(routes.root + "products/" + handle + "?section_id=" + section)
        .then(function (r) { return r.ok ? r.text() : ""; })
        .catch(function () { return ""; });
    })).then(function (chunks) {
      var html = chunks.map(function (c) {
        if (!c) return "";
        var tmp = document.createElement("div");
        tmp.innerHTML = c;
        var card = tmp.querySelector("[data-card]");
        return card ? card.outerHTML : "";
      }).join("");
      grid.innerHTML = html;
      if (!grid.innerHTML.trim()) {
        grid.setAttribute("hidden", "");
        if (empty) empty.removeAttribute("hidden");
      }
      paintWishButtons();
    });
  }

  if (document.querySelector("[data-wishlist-grid]")) renderProductList("[data-wishlist-grid]", getWishlist());
  if (document.querySelector("[data-viewed-grid]")) {
    var v = store(VIEWED_KEY, []).filter(function (h) { return h !== current; });
    if (v.length) renderProductList("[data-viewed-grid]", v);
    else {
      var sec = document.querySelector("[data-viewed-section]");
      if (sec) sec.setAttribute("hidden", "");
    }
  }

  /* -------------------------------- pretraga -------------------------------- */
  var searchOverlay = $("[data-search-overlay]");
  var searchInput = searchOverlay && searchOverlay.querySelector("input[type=search]");
  var searchResults = searchOverlay && searchOverlay.querySelector("[data-search-results]");
  var searchTimer = null;
  var lastQuery = "";

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 40);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove("is-open");
    document.body.style.overflow = "";
    if (searchInput) searchInput.value = "";
    if (searchResults) searchResults.innerHTML = "";
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-open]")) { e.preventDefault(); openSearch(); }
    if (e.target.closest("[data-search-close]")) { e.preventDefault(); closeSearch(); }
  });

  if (searchInput) {
    on(searchInput, "input", function () {
      var q = searchInput.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(searchTimer);
      if (q.length < 2) { if (searchResults) searchResults.innerHTML = ""; return; }
      searchTimer = setTimeout(function () {
        fetch(routes.predictiveSearch + "?q=" + encodeURIComponent(q) + "&section_id=predictive-search")
          .then(function (r) { return r.ok ? r.text() : ""; })
          .then(function (html) {
            if (!searchResults || !html) return;
            var tmp = document.createElement("div");
            tmp.innerHTML = html;
            var inner = tmp.querySelector("[data-predictive-inner]");
            searchResults.innerHTML = inner ? inner.innerHTML : "";
          })
          .catch(function () { /* tiho */ });
      }, 220);
    });
  }

  /* ---------------------- filteri i sortiranje (kolekcija) ------------------ */
  $$("[data-filter-form]").forEach(function (form) {
    on(form, "change", function (e) {
      if (e.target.matches("input, select")) form.submit();
    });
  });
  $$("[data-sort-select]").forEach(function (sel) {
    on(sel, "change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  });

  /* --------------------------- pisanje recenzije ---------------------------- */
  /* Judge.me formu otvara samo njihova plutajuća kartica (.jdgm-revs-tab-btn).
     Naša dugmad je pozivaju umesto da se oslanjaju na klasu koju Judge.me
     ne vezuje van svog widgeta. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-write-review]");
    if (!btn) return;
    e.preventDefault();
    var tab = document.querySelector(".jdgm-revs-tab-btn");
    if (tab) { tab.click(); return; }
    var widgetLink = document.querySelector(".jdgm-review-widget .jdgm-write-rev-link");
    if (widgetLink) { widgetLink.click(); return; }
    var sec = document.getElementById("recenzije");
    if (sec) sec.scrollIntoView({ behavior: "smooth" });
  });

  /* --------------------- „Prikaži sve recenzije" (proizvod) ----------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-reviews-more]");
    if (!btn) return;
    e.preventDefault();
    $$("[data-review-extra]").forEach(function (li) { li.removeAttribute("hidden"); });
    btn.remove();
  });

  /* ------------------------- preporuke (slični proizvodi) ------------------- */
  $$("[data-recommendations]").forEach(function (el) {
    var url = el.getAttribute("data-url");
    if (!url || el.querySelector(".product-grid")) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-recommendations]");
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          paintWishButtons();
        } else {
          el.setAttribute("hidden", "");
        }
      })
      .catch(function () { el.setAttribute("hidden", ""); });
  });

  /* --------------------------- „Prikaži još" (kolekcija) -------------------- */
  document.addEventListener("click", function (e) {
    var more = e.target.closest("[data-load-more]");
    if (!more) return;
    e.preventDefault();
    var url = more.getAttribute("href");
    if (!url || more.dataset.loading) return;
    more.dataset.loading = "1";
    var label = more.textContent;
    more.textContent = strings.loading || "Učitavanje…";

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var incoming = doc.querySelector("[data-product-grid]");
        var grid = $("[data-product-grid]");
        if (incoming && grid) {
          Array.prototype.forEach.call(incoming.children, function (node) {
            grid.appendChild(node.cloneNode(true));
          });
        }
        var nextBtn = doc.querySelector("[data-load-more]");
        if (nextBtn) {
          more.setAttribute("href", nextBtn.getAttribute("href"));
          more.textContent = label;
          delete more.dataset.loading;
        } else {
          more.remove();
        }
        if (history.replaceState) history.replaceState({}, "", url);
        paintWishButtons();
      })
      .catch(function () {
        more.textContent = label;
        delete more.dataset.loading;
      });
  });

  /* --------------------------------- chat ----------------------------------- */
  var chatPanel = $("[data-chat-panel]");
  if (chatPanel) {
    var chatLog = $("[data-chat-log]", chatPanel);
    var chatForm = $("[data-chat-form]", chatPanel);
    var chatInput = chatForm && chatForm.querySelector("input");
    var fab = $("[data-chat-toggle]");
    var quickWrap = $("[data-chat-quick]", chatPanel);

    function bubble(text, from) {
      var el = document.createElement("div");
      el.className = "chat-msg chat-msg--" + from;
      el.textContent = text;
      if (quickWrap && quickWrap.parentElement === chatLog) chatLog.insertBefore(el, quickWrap);
      else chatLog.appendChild(el);
      chatLog.scrollTop = chatLog.scrollHeight;
    }

    function ask(question) {
      bubble(question, "user");
      var answer = null;
      $$("[data-chat-q]", quickWrap || chatPanel).forEach(function (b) {
        if (b.getAttribute("data-chat-q") === question) answer = b.getAttribute("data-chat-a");
      });
      setTimeout(function () {
        bubble(answer || chatPanel.getAttribute("data-fallback") || "", "bot");
      }, 450);
    }

    on(fab, "click", function () {
      var open = chatPanel.classList.toggle("is-open");
      fab.setAttribute("aria-expanded", open ? "true" : "false");
      var lbl = fab.querySelector("[data-chat-label]");
      if (lbl) lbl.textContent = open ? (strings.chatClose || "ZATVORI") : (strings.chatOpen || "PITAJ NAS");
      var ic = fab.querySelectorAll("[data-chat-icon]");
      if (ic.length === 2) {
        ic[0].toggleAttribute("hidden", open);
        ic[1].toggleAttribute("hidden", !open);
      }
      if (open && chatInput) chatInput.focus();
    });

    on($("[data-chat-close]", chatPanel), "click", function () {
      chatPanel.classList.remove("is-open");
      if (fab) fab.setAttribute("aria-expanded", "false");
    });

    on(chatPanel, "click", function (e) {
      var q = e.target.closest("[data-chat-q]");
      if (q) { e.preventDefault(); ask(q.getAttribute("data-chat-q")); }
    });

    on(chatForm, "submit", function (e) {
      e.preventDefault();
      var text = chatInput.value.trim();
      if (!text) return;
      chatInput.value = "";
      ask(text);
    });
  }

  /* ------------------------- newsletter potvrda (footer) -------------------- */
  if (window.location.search.indexOf("customer_posted=true") !== -1) {
    toast(strings.newsletterOk || "Hvala! Prijava na newsletter je zabeležena.");
  }

  /* ---------------------- ponovno vezivanje posle editora ------------------- */
  document.addEventListener("shopify:section:load", function () { paintWishButtons(); });

  window.AFRODITA = T;
})();
